//
//
//
//
//
//
//
//
//
//

import { Topic } from "@/models";
import PostTopic from "@/pages/PostTopic.vue";
import JielongTopic from "@/pages/JielongTopic.vue";
import FeihuaTopic from "@/pages/FeihuaTopic.vue";

export default {
  name: "topic",
  async created() {
    let id = this.$route.params.id;

    let topic = await Topic.getById(id);
    this.topic = topic;

    this.$initWechat().then(() => {
      this.$initWechatShare({
        title: this.title,
        link: location.href,
        image: topic.get("coverForShare")
          ? topic.get("coverForShare").url()
          : topic.get("cover").url(),
        desc: this.description
      });
    });
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: null,
      meta: [{ name: "description", content: this.description }]
    };
  },
  data() {
    return {
      topic: null
    };
  },
  methods: {},

  computed: {
    title: function() {
      return this.topic ? this.topic.get("title") + " · 西窗烛" : "西窗烛";
    },
    description: function() {
      if (!this.topic) {
        return "";
      }

      return this.topic.get("desc");
    }
  },
  components: {
    PostTopic,
    JielongTopic,
    FeihuaTopic
  }
};



// WEBPACK FOOTER //
// ./src/pages/Topic.vue